import { render } from "./HeaderColonialMarket.vue.vue?vue&type=template&id=42530ebd&scoped=true"
import script from "./HeaderColonialMarket.vue.vue?vue&type=script&lang=js"
export * from "./HeaderColonialMarket.vue.vue?vue&type=script&lang=js"

import "./HeaderColonialMarket.vue.vue?vue&type=style&index=0&id=42530ebd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42530ebd"]])

export default __exports__